import React from 'react';

function StarBorderIcon({ size = 14 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#FDCB2C"
        d="M11.356 13.6L7 10.4l-4.356 3.2 1.673-5.17-4.354-3.18h5.375L7 .07l1.662 5.18h5.374L9.683 8.43l1.673 5.17zM7 8.952l2.134 1.57-.817-2.535 2.146-1.57H7.811l-.81-2.526-.812 2.526H3.536l2.149 1.57-.817 2.534L7 8.951z"
      ></path>
    </svg>
  );
}

export default StarBorderIcon;
